const variants: any = {
  layout: {
    container: {
      maxWidth: 'container',
    },
    medium: {
      maxWidth: 'medium',
    },
    blog: {
      maxWidth: 'blog',
    },
  },
  forms: {
    label: {
      // fontFamily: ''
    },
  },
  buttons: {
    primary: {
      fontFamily: 'mono',
      color: 'primary',
      border: '0.125em solid',
      borderRadius: 0,
      background: 'transparent',
      '&:hover': {
        color: 'secondary',
      },
    },
  },
  text: {
    heading: {
      fontFamily: 'heading',
      fontWeight: 'heading',
      lineHeight: 'heading',
    },
    mono: {
      fontFamily: 'mono',
      fontWeight: 'mono',
      lineHeight: 'mono',
    },
  },
};

export default variants;
